import { createAsyncThunk } from '@reduxjs/toolkit';
import { setLoading } from '../global';
import axios from 'axios';
import { AdditionalDetails, GenericRequestStatus } from './GenericRequestSlice';
import { bearerAuth } from '../auth';


export const getGenericRequest = createAsyncThunk(
    'genericRequest/getGenericRequest', ({jwtToken, frontendCorrelationKey}: { jwtToken: string | undefined, frontendCorrelationKey: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));

        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };
        return axios.get('/genericRequest/' + frontendCorrelationKey, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const findGenericRequestsByStatus = createAsyncThunk(
    'genericRequest/findGenericRequestsByStatus', ({jwtToken, status}: { jwtToken: string | undefined, status: GenericRequestStatus | GenericRequestStatus[] }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        return axios.get('/genericRequest/status/' + (Array.isArray(status) ? status.join(',') : status), config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const addGenericRequest = createAsyncThunk(
    'genericRequest/addGenericRequest', ({jwtToken, additionalDetails, requestType, walletUrl}: { jwtToken: string | undefined, additionalDetails: AdditionalDetails, requestType: string, walletUrl: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));

        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };
        const body = {
            additionalJson: additionalDetails,
            requestType: requestType,
            walletUrl: walletUrl
        } as any;

        return axios.post('/genericRequest', body, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const saveGenericRequest = createAsyncThunk(
    'genericRequest/saveGenericRequest', ({jwtToken, frontendCorrelationKey, additionalDetails, status}: { jwtToken: string | undefined, frontendCorrelationKey: string, additionalDetails: AdditionalDetails, status?: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));

        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };
        const body = {
            additionalJson: additionalDetails
        } as any;

        if (status) {
            body.status = status;
        }
        return axios.put('/genericRequest/' + frontendCorrelationKey, body, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const signGenericRequest = createAsyncThunk(
    'genericRequest/signGenericRequest', ({jwtToken, frontendCorrelationKey}: { jwtToken: string | undefined, frontendCorrelationKey: string}, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));

        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };
        const body = {
        } as any;

        return axios.put('/genericRequest/' + frontendCorrelationKey + "/sign", body, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);


export const issueCredential = createAsyncThunk(
    'genericRequest/issueCredential', ({jwtToken, correlationId, credentialIssuerTemplateKey}: { jwtToken: string | undefined, correlationId: string, credentialIssuerTemplateKey: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };
        const body = {};

        let url = '/genericRequest/issueCredential/' + correlationId + '/' + credentialIssuerTemplateKey;
        return axios.post(url, body, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);



